export function deleteEmojiBackward({state, dispatch}) {
  if (state.selection.main.empty) {
    const position = state.selection.main.from;
    const offset = stepOverLength(state, position);
    const node = state.tree.topNode.resolve(position - offset, -1);
    if (node.name === 'Emoji') {
      dispatch({changes: [{from: node.from, to: node.to + offset}]});
      return true;
    }
  }
  return false;
}

function stepOverLength(state, position) {
  if (stringBefore(state, position) === ' ') {
    return 1;
  }
  return 0;
}

function stringBefore(state, from) {
  return state.doc.sliceString(from - 1, from);
}
